<template>
  <div style="width: 100%">
    <HomeDetailInfoSiteOne>
      <template #header-one>
        <h1 style="max-width: 800px"> There is no TAKT network around the world. So we will provide you our network if you need help developing TAKT on your construction site.   </h1>
      </template>
      <template #text-one>
        <div style="display: flex; flex-direction: column; padding: 20px; gap: 20px">
        <HomeDetailInfoSiteTwo>
          <template #header>
            <h1 style="padding-top: 10px; font-style: normal;"> TAKT.friends </h1>
          </template>
          <template #description>
            <p :style="`
            font-style: normal;
            font-size: 20px;
            ${$vuetify.breakpoint.smAndDown ? '' : ''}`">
            We love to talk about TAKT. So we are always open to learn more and share our insights of TAKT. We try to connect to everyone using TAKT in construction.
            </p>
          </template>
          <template #desktop-button>
            <div :style="`display: flex; flex-direction: column;font-style: normal; justify-content: center; ${$vuetify.breakpoint.smAndDown ? 'align-items: center' : 'height: 100%; padding-left: 25px;'} `">
              <h3 style="padding: 10px"> Start being a TAKT.friend</h3>
            </div>
          </template>
        </HomeDetailInfoSiteTwo>
        <HomeDetailInfoSiteTwo>
          <template #header>
            <h1 style="padding-top: 10px; font-style: normal;"> TAKT.trainer </h1>
          </template>
          <template #description>
            <p :style="`
            font-style: normal;
            font-size: 20px;
            ${$vuetify.breakpoint.smAndDown ? '' : ''}`">
            Do you need an implementation of TAKT in your construction project? We are connected to a lot consutants and trainers and we train them by our self. All trainers are able to train TAKT by the TAKT.simulation and the TAKT.app.
            </p>
          </template>
          <template #desktop-button>
            <div :style="`display: flex; flex-direction: column;font-style: normal;justify-content: center; ${$vuetify.breakpoint.smAndDown ? 'align-items: center' : 'height: 100%; padding-left: 25px;'} `">
              <h3 style="padding: 10px"> Start your training as a TAKT.trainer
               </h3>

            </div>
          </template>
        </HomeDetailInfoSiteTwo>
      </div>
      </template>
    </HomeDetailInfoSiteOne>

  </div>
</template>

<script>
import HomeDetailInfoSiteTwo from '@/components/Home/HomeDetailInfoSiteTwo.component.vue'
import HomeDetailInfoSiteOne from '@/components/Home/HomeDetailInfoSiteOne.component.vue'
export default {
  components: {
    HomeDetailInfoSiteTwo,
    HomeDetailInfoSiteOne
  }
}
</script>
